import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Constant } from '../../../environments/constants';
import { Subscription } from 'rxjs';
import { ContextService } from '../../services/context/context.service';
import { DataService } from '../../services/context/data.service';
import { UIStateService } from '../../services/context/uistate.service';
import { AccountsService } from '../../services/accounts.service';
import { AppMonitoringService } from '../../services/util/app-monitoring.service';
import * as fromModel from '../../services/models';
import { MatDialog } from '@angular/material/dialog';
import {MatTableDataSource} from '@angular/material/table';
import {SelectionModel} from '@angular/cdk/collections';
import { RefDataService } from '../../services/context/ref-data.service';

import { EditSavingComponent } from '../edit-savings/edit-saving.component';

@Component({
  selector: 'gp-account-summary',
  templateUrl: './account-summary.component.html',
  styleUrls: ['./account-summary.component.scss']
})
export class AccountSummaryComponent implements OnInit, OnChanges, OnDestroy {


  @Input("Refresh") refresh: string;
  
  protected _storeDataSubscription: Subscription;
  accountTypeMenuItems;
  
  Accounts: any = [];
  accounts: any = [];
  SelectedAccounts: any = [];
  displayedColumns: string[] = ['select', 'id', 'taxstatus', 'modelName', 'AccountKPIs.AccountTotal'];
  dataSource = new MatTableDataSource<any>(this.Accounts);
  selection = new SelectionModel<any>(true, []);

  isDataChanged = false;
  clientMenuItems = [];

  constructor(private accountsService: AccountsService,
    private contextService:ContextService,
    private refDataService: RefDataService,
    private dataService:DataService,
    private uiStateService: UIStateService,
    private dialog: MatDialog, 
    private appMonitoringService: AppMonitoringService) {      
    }

  ngOnInit(): void {
    if(this.contextService.context.Account && this.contextService.context.Account.length>0){
      //this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.SHOWPROGRESSBAR, "AccountListComponent-ngOnInit", true);
        //this.dataService.getAccounts(this.contextService.context.Account);        
    }

    let clients: fromModel.PlanClient[] = this.dataService.getPlanPrimarSecondaryOwners();
    if(clients && clients.length>0){
      clients.forEach(cl => {
        this.clientMenuItems.push({clientid: cl.clientid, displayClientname: `${cl.clientname}`});    
      });
    }


    this._storeDataSubscription = this.dataService.subscribe((appData: fromModel.IAppData) => this.populateAppData(appData));   
  }

  ngOnChanges(changes: SimpleChanges) {
    this.accounts = [];
    this.isDataChanged = false;
    this.populateAccounts();  

              
  }

  private populateAppData(appData: fromModel.IAppData){
    this.Accounts = [];
    if(appData && appData.action!==fromModel.DATA_ACTION.NONE){
      this.populateAccounts();
      
    }
  }

  populateAccounts(){

    let id;
    let isIncluded;
    let CustodianType;
    let CustodyAccount;
    let gfoCustodyAccount;
    let CustodianName;
    let LegalEntityID;
    let LegalEntityName;
    let registrationDesc;
    let AccountTotal;
    let taxstatus;
    let taxStatusColor;
    let savings;
    let cContribution;
    let eContribution;
    let accountNickname; 

    this.Accounts = this.dataService.getPlanAccountDetails();
    this.Accounts.forEach(acc => {

      if(acc.CustodianType === fromModel.CUSTODIANTYPE.HypoEA){
        CustodyAccount = '';
        gfoCustodyAccount = '';
        CustodianName = '';
        LegalEntityName = acc.clientname;
        LegalEntityID = acc.clientid;
        registrationDesc = acc.actTypeDesc;
        AccountTotal = acc.mktValue;
        accountNickname = acc.name;
      } else {                
        CustodyAccount = acc.CustodyAccount;
        gfoCustodyAccount = acc.gfoCustodyAccount;
        CustodianName = acc.CustodianName;
        LegalEntityID = acc.LegalEntityID
        LegalEntityName = acc.LegalEntityName;
        registrationDesc = acc.registrationDesc;
        AccountTotal = acc.AccountKPIs.AccountTotal; 
        accountNickname = acc.AccountNickname;       
      }

      id = acc.id;
      isIncluded = acc.isIncluded;
      CustodianType = acc. CustodianType;
      taxstatus = acc.taxstatus;
      taxStatusColor = acc.taxStatusColor;
      cContribution = this.dataService.getContributionByTypeAccId(fromModel.SAVINGSTYPE.SC, acc.id);
      eContribution = this.dataService.getContributionByTypeAccId(fromModel.SAVINGSTYPE.EC, acc.id);

      const tempAcc = this.accounts.find(_acc=>_acc.id === id);
      if(tempAcc){
        if(acc.CustodianType === fromModel.CUSTODIANTYPE.HypoEA){
          tempAcc.CustodyAccount = '';
          tempAcc.gfoCustodyAccount = '';
          tempAcc.CustodianName ='';
          tempAcc.LegalEntityID = acc.clientid;
          tempAcc.LegalEntityName = acc.clientname;
          tempAcc.registrationDesc = acc.actTypeDesc;
          tempAcc.AccountTotal = acc.mktValue;
          tempAcc.accountNickname = acc.name;

        } else {
          tempAcc.CustodyAccount = acc.CustodyAccount;
          tempAcc.gfoCustodyAccount = acc.gfoCustodyAccount;
          tempAcc.CustodianName = acc.CustodianName;
          tempAcc.LegalEntityName = acc.LegalEntityName;
          tempAcc.LegalEntityID = acc.LegalEntityID;
          tempAcc.registrationDesc = acc.registrationDesc;
          tempAcc.AccountTotal = acc.AccountKPIs.AccountTotal;
          tempAcc.accountNickname = acc.AccountNickname;
        }
        tempAcc.CustodianType = acc. CustodianType;        
        tempAcc.cContribution = cContribution;
        tempAcc.eContribution = eContribution;
        tempAcc.taxstatus = acc.taxstatus;  
        tempAcc.taxStatusColor = acc.taxStatusColor;      
      } else {
          this.accounts.push({id: id, CustodianType: CustodianType, CustodyAccount: CustodyAccount, accountNickname: accountNickname,
            gfoCustodyAccount: gfoCustodyAccount, CustodianName: CustodianName, LegalEntityID: LegalEntityID, LegalEntityName: LegalEntityName, registrationDesc:registrationDesc,
            AccountTotal: AccountTotal, cContribution: cContribution, eContribution: eContribution, taxstatus: taxstatus, isIncluded: isIncluded, taxStatusColor:taxStatusColor });
      }
    });
  }

  // getTaxStatusColor(taxStatus): string{   
  //   return this.refDataService.getPlanningUIRefDataByTypeCode(fromModel.PLANNINGUIREFTYPE.Colors,taxStatus.replace('-','').toUpperCase()).value;
  // }




  saveSelectedAccounts1() {
    // let selectedAccount = [];
    // this.selection.selected.forEach(s => selectedAccount.push(s.id));
    // this.contextService.dispatchAction(fromModel.APP_ACTION.SELECTEDACCOUNTS, "AccountListComponent-changeAccountSelection", selectedAccount);
    // this.dataService.dispatchAction(fromModel.DATA_ACTION.SELECTEDPLANACCOUNTS, "AccountListComponent-changeAccountSelection", selectedAccount);
    this.dataService.savePlan();
}

  saveSelectedAccounts() {    
    let selectedAccounts = [];
    let selectedEAAccounts = [];

    this.accounts.forEach(acc => {
      if(acc.isIncluded){
        if(acc.CustodianType === fromModel.CUSTODIANTYPE.HypoEA){
          selectedEAAccounts.push(acc.id);
        } else {
          selectedAccounts.push(acc.id);
        }
      }
    });
    this.contextService.dispatchAction(fromModel.APP_ACTION.SELECTEDACCOUNTS, "AccountSummaryComponent-changeAccountSelection", {selectedAccounts: selectedAccounts, selectedEAAccounts: selectedEAAccounts});
    //this.contextService.dispatchAction(fromModel.APP_ACTION.SELECTEDACCOUNTS, "AccountSummaryComponent-changeAccountSelection", selectedAccounts);
    this.dataService.dispatchAction(fromModel.DATA_ACTION.SELECTEDPLANACCOUNTS, "AccountSummaryComponent-saveSelectedAccounts", {selectedAccounts: selectedAccounts, selectedEAAccounts: selectedEAAccounts});
    this.dataService.savePlan();
}


addAccounts(a,b){

}

editAccount(accountId){
  //alert('Edit: ' + accountId);
  this.openModelDialog(fromModel.OPENDIALOGACTIONS.EDITSAVING, accountId);
} 

selectAccount(accountId){
  //alert("Selected: " + accountId);
  let account = this.accounts.find(acc=> acc.id === accountId);
  if(account){
    account.isIncluded = !account.isIncluded;
    this.isDataChanged = true;
  }
}

addHypotheticalAccount(clientid){
  window.open(Constant.uri.createEA + clientid, 'eawindow');
}

editHypotheticalAccount(eaid, clientid){
  window.open(`${Constant.uri.editEA}${eaid}?cid=${clientid}`, 'eawindow');
}

refreshEA(){
  this.dataService.dispatchAction(fromModel.DATA_ACTION.RESETRESULTS, "AccountSummaryComponent-refresh",null);
  this.dataService.dispatchAction(fromModel.DATA_ACTION.EXTERNALACCOUNTS, "AccountSummaryComponent-refresh", null);    
  this.dataService.getExternalAccountListByClientIds();  
}

openModelDialog(action: fromModel.OPENDIALOGACTIONS, parm1?: string, parm2?: string){
  switch(action){
    case fromModel.OPENDIALOGACTIONS.EDITSAVING: {
      const dialogRef = this.dialog.open(EditSavingComponent, {
        width: '70%',
        height: '70%',
        data: {accountId: parm1}, 
        //data: expense,
        disableClose: true    
        }).afterClosed()
        .subscribe(result => {
          if(result && result.isSaved && result.expense && result.expense.isIncluded){
            //this.refreshExpense(result.expense);              
            //this.UpdateIncome.emit();
          }
        });        
      break;
    }
  }
}
  

  ngOnDestroy(): void{
    if(this._storeDataSubscription && this._storeDataSubscription !== null){
      this._storeDataSubscription.unsubscribe();
    }        
  }
}
